import { render, staticRenderFns } from "./XhUserCell.vue?vue&type=template&id=5c8d131a&scoped=true&"
import script from "./XhUserCell.vue?vue&type=script&lang=js&"
export * from "./XhUserCell.vue?vue&type=script&lang=js&"
import style0 from "./XhUserCell.vue?vue&type=style&index=0&id=5c8d131a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d131a",
  null
  
)

component.options.__file = "XhUserCell.vue"
export default component.exports